import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearRegisterMobileNumberAction,
  generateOtpAction,
  loginNetworkPortalAction,
  loginServiceProviderAction,
  loginWithRedirectionTokenAction,
} from "../../redux/actions/loginAction";
import { PhoneIcon } from "../../Utils/SvgIcons";
import {
  getNetworkMenuId,
  getRole,
  getShowDefaultMenu,
  getToken,
} from "../../Utils/types";

const GenerateOtp = () => {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [mobileNumber, setMobileNumber] = useState("");
  const [loginWithOtp, setLoginWithOtp] = useState(false);
  const [isViewPassword, setIsViewPassword] = useState(false);
  const [role, setRole] = useState("ServiceProvider");
  const [emailPassword, setEmailPassword] = useState({
    emailId: "",
    password: "",
  });

  useEffect(() => {
    const url = new URL(window.location.href);
    const redirectionToken = url.searchParams.get("redirectionToken");
    if (redirectionToken) {
      localStorage.clear();
      dispatch(loginWithRedirectionTokenAction(redirectionToken, navigate));
    }
  }, []);

  useEffect(() => {
    dispatch(clearRegisterMobileNumberAction());
    if (getToken() && getRole() === "ServiceProvider") {
      navigate(getShowDefaultMenu());
    }
    if (getToken() && getRole() === "NetworkAdmin") {
      navigate(getNetworkMenuId()?.url);
    }
  }, []);

  useEffect(() => {
    if (!getToken()) {
      localStorage.setItem("providerPortalSource", role);
    }
  }, [role, getToken()]);

  const generateOtpButton = async (e) => {
    await dispatch(generateOtpAction(mobileNumber, navigate));
  };

  return (
    <div className="login-container">
      <div className="left-container login-left-container">
        <div className="logo">
          <img
            src="https://live.healthassure.in/ProvidersPortal/images/HealthAssureLogo1.png"
            className="login-img img-fluid"
            alt="logo"
          />
          <div className="mb-5">
            <h2 className="login-h2">Login</h2>
            <p className="login-p">
              {loginWithOtp
                ? "Enter Your Registered Email Id / Mobile Number"
                : "Enter Your Registered Email Address and Password"}
            </p>
          </div>
          <div className="custom-tabs">
            <ul className="nav nav-pills mb-3">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    role === "ServiceProvider" && "active"
                  }`}
                  type="button"
                  onClick={() => {
                    setRole("ServiceProvider");
                    setEmailPassword({
                      emailId: "",
                      password: "",
                    });
                  }}
                >
                  Service Provider
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${role === "NetworkAdmin" && "active"}`}
                  type="button"
                  onClick={() => {
                    setRole("NetworkAdmin");
                    setLoginWithOtp(false);
                    setEmailPassword({
                      emailId: "",
                      password: "",
                    });
                  }}
                >
                  Network Admin
                </button>
              </li>
            </ul>
            <div className="user-input-field">
              {!loginWithOtp && (
                <>
                  <input
                    className="form-control login-input"
                    type="email"
                    value={emailPassword?.emailId}
                    pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$"
                    placeholder="Email Address"
                    onChange={(e) =>
                      setEmailPassword({
                        ...emailPassword,
                        emailId: e.target.value,
                      })
                    }
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        document.getElementById("loginbutton").click();
                      }
                    }}
                  />
                  <div className="user-input-field user-input-field-shadow">
                    <input
                      className="form-control login-input login-input-shadow"
                      type={isViewPassword ? "text" : "password"}
                      placeholder="Password"
                      value={emailPassword?.password}
                      onChange={(e) =>
                        setEmailPassword({
                          ...emailPassword,
                          password: e.target.value,
                        })
                      }
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          document.getElementById("loginbutton").click();
                        }
                      }}
                    />
                    <label
                      className="login-input-img img-eye"
                      onClick={() =>
                        setIsViewPassword(
                          isViewPassword ? false : !isViewPassword && true
                        )
                      }
                    >
                      {isViewPassword ? (
                        <i className="fa fa-eye"></i>
                      ) : (
                        <i className="fa fa-eye-slash"></i>
                      )}
                    </label>
                  </div>
                </>
              )}
              {loginWithOtp && (
                <input
                  className="form-control login-input"
                  type="text"
                  placeholder="Email Id / Mobile Number"
                  onChange={(e) => setMobileNumber(e.target.value)}
                  onKeyPress={(event) => {
                    if (event.key === "Enter") {
                      generateOtpButton(event);
                    }
                  }}
                />
              )}
              {role === "ServiceProvider" && (
                <div className="via-otp-div">
                  <input
                    type="checkbox"
                    value={!loginWithOtp}
                    onClick={() =>
                      setLoginWithOtp(
                        loginWithOtp ? false : !loginWithOtp && true
                      )
                    }
                    className="otp-check"
                  />
                  <p>Login With OTP</p>
                </div>
              )}
            </div>
            <button
              type="button"
              id="loginbutton"
              onClick={() =>
                loginWithOtp
                  ? generateOtpButton()
                  : role === "ServiceProvider"
                  ? dispatch(
                      loginServiceProviderAction(emailPassword, navigate)
                    )
                  : dispatch(loginNetworkPortalAction(emailPassword, navigate))
              }
              className="login-button"
            >
              {loginWithOtp ? "Get OTP" : "Login"}
            </button>
          </div>
        </div>
      </div>
      <div className="right-container">
        <div className="bottom-card">
          <h2>2500+ Strong Diagnostic Partner Network across the country</h2>
          <img
            className="group-star"
            src="https://uat.healthassure.in/ProvidersPortal/images/groupstar.svg"
            alt="groupstar"
          />
          <p className="f-14">1000 + Providers are already using this Portal</p>
          <a href="tel:022-61676600" className="call-button">
            {window.innerWidth > 900 ? (
              <PhoneIcon color="white" />
            ) : (
              <PhoneIcon color="#0061fe" />
            )}
            <span style={{ fontSize: "18px" }}>022-61676600</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default GenerateOtp;
